<template>
  <div class="bio-wrapper" id="getToKnowUs">
    <div class="bio-container-lg">
      <div class="sahil-container clearfix">
        <img class="float-right ml-5" src="@/assets/sahil-bhasin.png" alt="Sahil Bhasin" />
        <div class="bio p-5">
          <h2 class="display-4 mb-4">Get To Know Us</h2>
          <h5 class="card-title">Sahil Bhasin</h5>
          <p>Founder and Director</p>
          <p>
            Sahil is at the forefront of Melbourne’s property industry. Recognized as one of the
            inner city's most respected and talented agents, he is often referred to as the agent
            that "doesn’t sleep". Often quoted in the media and asked by government to advise on
            policy, Sahil is considered an industry expert for all things property.
          </p>
          <p>
            Sahil’s exceptional sales and negotiation skills are reflected in his ongoing success.
            His high percentage of repeat and referral business is built on excellent customer
            rapport and a clear understanding of his client’s needs. Working diligently to secure
            the best price for his vendors and landlords, Sahil is a knowledgeable communicator who
            knows the ins and outs of the property market.
          </p>
          <p class="mb-2">
            P
            <span>0403 630 215</span>
          </p>
          <p class="mb-5">
            E
            <a href="mailto:sahil@bricksamortar.com.au">
              <span>sahil@bricksamortar.com.au</span>
            </a>
          </p>
          <p class="mb-4">
            <a class="social" href="https://www.facebook.com/bricksamortar/" target="_blank">
              <span class="fab fa-fw fa-facebook-f"></span>
            </a>
            <a class="social" href="https://www.instagram.com/bricksamortar/" target="_blank">
              <span class="fab fa-fw fa-instagram"></span>
            </a>
            <a class="social" href="https://www.linkedin.com/in/sahil-bhasin/" target="_blank">
              <span class="fab fa-fw fa-linkedin-in"></span>
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="bio-container-sm container py-5">
      <h2 class="display-4 mb-4">Get To Know Us</h2>
      <div class="row">
        <div class="col-md-6">
          <img src="@/assets/sahil-bhasin.jpg" alt="Sahil Bhasin" />
        </div>
        <div class="col-md-6">
          <div class="bio mb-5 mt-4 mt-md-0">
            <h5 class="card-title">Sahil Bhasin</h5>
            <p>Founder and Director</p>
            <p>
              Sahil has been at the forefront of Melbourne’s property industry. Recognized as one of
              the inner city's most respected and talented agents, he is often referred to as the
              agent that "doesn’t sleep". Often quoted in the media; and asked by government to
              advise on policy, Sahil is considered an industry expert for all things property.
            </p>
            <p>
              Sahil’s exceptional sales and negotiation skills are reflected in his ongoing success.
              His high percentage of repeat and referral business is built on excellent customer
              rapport and a clear understanding of his client’s needs. Working diligently to secure
              the best price for his vendors and landlords, Sahil is a knowledgeable communicator
              who knows the ins and outs of the property market.
            </p>
            <p class="mb-2">
              P
              <span>0403 630 215</span>
            </p>
            <p class="mb-4">
              E
              <a href="mailto:sahil@bricksamortar.com.au">
                <span>sahil@bricksamortar.com.au</span>
              </a>
            </p>
            <p class="mb-4">
              <a class="social" href="https://www.facebook.com/bricksamortar/" target="_blank">
                <span class="fab fa-fw fa-facebook-f"></span>
              </a>
              <a class="social" href="https://www.instagram.com/bricksamortar/" target="_blank">
                <span class="fab fa-fw fa-instagram"></span>
              </a>
              <a class="social" href="https://www.linkedin.com/in/sahil-bhasin/" target="_blank">
                <span class="fab fa-fw fa-linkedin-in"></span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="full-image"></div>
  </div>
</template>

<style lang="scss">
.bio {
  a.social {
    background: #212529;
    display: inline-block;
    padding: 2px;
    margin-right: 5px;
    span {
      width: 1.75rem;
      font-size: 1.5rem;
      color: white;
    }
    .fa-facebook-f {
      position: relative;
      bottom: -4px;
      right: -3px;
    }
    .fa-instagram {
      position: relative;
      bottom: -1px;
    }
  }
}
.bio-container-lg {
  position: relative;
  .bio {
    p {
      margin-bottom: 2rem;
    }
  }
  img {
    position: relative;
    z-index: 1;
  }
}
.bio-container-lg {
  display: none;
}
.bio-container-sm {
  display: block;
  img {
    max-width: 591px;
    width: 100%;
  }

  .row {
    margin-bottom: 40px;
  }
}
@media (min-width: 1920px) {
  .bio-container-sm {
    display: none;
  }
  .bio-wrapper {
    background: #51514f;
  }
  .bio-container-lg {
    display: block;
    background: #fff;
    margin: auto;
    width: 100%;
    height: 36.9vw;
    img {
      height: auto;
      width: calc(53.9vw);
    }
    .bio {
      height: 36.9vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .sahil-container .bio {
    padding-left: 160px !important;
  }
}

.full-image {
  height: 50vw;
  min-height: 250px;
  max-height: 1000px;
  background-repeat: no-repeat;
  background-image: url("../assets/content/team.jpg");
  background-size: cover;
  background-position: center;
}
</style>

<script>
export default {
  name: "GetToKnowUs"
};
</script>
